export default [
    {path: '/tokens/:id/edit', screen: 'token/EditToken', secured: true, role: ['admin']},
    {path: '/tokens/:id', screen: 'token/DisplayToken', secured: true, role: ['admin']},
    {path: '/tokens', screen: 'token/ListTokens', secured: true, role: ['admin']},
    {path: '/token/new', screen: 'token/CreateToken', secured: true, role: ['admin']},
]